import React from "react";
import AdminLayout from "../../hoc/adminLayout";

const Admin = () => {
  return (
    <AdminLayout>
      <div className="user_dashboard">
        <div>Admin Panel</div>
      </div>
    </AdminLayout>
  );
};

export default Admin;
